/**
 * RESPONSIBILITY: the feature flags THIS SITE declares.
 *
 * The framework ships its own (the account bar, the dev bar, section outlines); these
 * are the site's. Registering here rather than in the framework keeps the codes in one
 * place, which is what stops two flags claiming the same letter.
 */
import { registerFlag } from '@framework/react';

/**
 * The theme editor's pencil.
 *
 * OFF by default, and deliberately not a permanent fixture: a chip floating over the
 * corner of every page is editor chrome that a visitor never needs, and even an admin
 * only wants it on the day they are changing the palette. It lives behind a toggle in
 * the account menu, where the people who can use it already are.
 *
 * Turning it on shows the pencil; it does not grant permission. The section is still
 * WRITE=NONE, so the server refuses anyone but an admin whatever this says.
 */
export const FLAG_THEME_PENCIL = registerFlag({
  code: 'T',
  key: 'themePencil',
  label: 'Theme editor',
  description:
    'Show the theme pencil, for editing the site palette and fonts. Admin only — the '
    + 'flag reveals the control, the server still decides whether a save is allowed.',
});
